import React from 'react';
import { Button } from '@mui/material';
import classnames from 'classnames/bind';
import logo from '../../assets/logo.png';
import styles from './Header.module.scss';

const cx = classnames.bind(styles);

export default function Header() {
    return (
        <header className={cx('Header')}>
            <a href='/' className={cx('Brand')}>
                <img src={logo} alt='Shadowpilot logo' className={cx('Logo')} />
                <span className={cx('Wordmark')}>Shadowpilot</span>
            </a>

            <nav className={cx('Nav')}>
                <a href='#how-it-works' className={cx('NavLink')}>
                    How it works
                </a>
                <a href='#capabilities' className={cx('NavLink')}>
                    Capabilities
                </a>
            </nav>

            <Button variant='outlined' color='inherit' href='#waitlist' className={cx('CtaButton')}>
                Join the waitlist
            </Button>
        </header>
    );
}
